import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import OnboardingPayment from "./OnboardingPayment";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const OnboardingPaymentWrapper = () => {
  return (
    <Elements stripe={stripePromise}>
      <OnboardingPayment />
    </Elements>
  );
};

export default OnboardingPaymentWrapper;
